import BaseController from '@humandigital-agency/base-controller';
import * as HeliomareShare from './share';

export default class ShareController extends BaseController {
    constructor() {
        super('.shareContainer', HeliomareShare.HeliomareShare);
    }
    
    bindEvents(tag, media) {
        tag.addEventListener('click', e => {
            e.preventDefault();

            if (media == 'native') {
                const data = {
                    title: this.title,
                    description: this.description,
                    url: this.url
                };

                try {
                    navigator.share(data);
                } catch (e) {
                    if (console && console.error) {
                        console.error(e);
                    }
                }
            } else {
                window.open(tag.href, 'NewWindow', `menubar=no,toolbar=no,status=no,width=570,height=570,top=${(screen.height - 570) / 2},left=${(screen.width - 570) / 2}`);
            }
        });
    }
}